<script setup lang="ts">
import StfFileInput from '@/ui/file-input/StfFileInput.vue';
import {computed, ref} from 'vue';
import {uploadTrademarkImage} from '@/components/mark-view/uploadTrademarkImage';
import useCountry from '@/composables/countryDependable';
import {useApplicationStore} from '@/store/application';
import {useTrademarkStore} from '@/store/mark';
import {storeToRefs} from 'pinia';

const trademarkStore = useTrademarkStore();

const country = useCountry();
const applicationStore = useApplicationStore();
const loading = ref(false);
const error = ref<string|null>(null);
const {trademarkImageUrl} = storeToRefs(trademarkStore);

const uploadImage = async (file: File) => {
    loading.value = true;
    error.value = null;
    const data = await uploadTrademarkImage(file, applicationStore.appReference, country.displayCode);

    if (data.error) {
        error.value = data.error;
    }

    if (data.url) {
        trademarkStore.addTrademarkImage(data);
    }

    loading.value = false;
};

const removeImage = () => {
    trademarkStore.addTrademarkImage(null);
}

const helperText = computed(() => {
    let typeText = country.imageOptions.fileType
        .map(type => type.replace('.', '').toUpperCase())
        .join(', ');

    //replace the last comma with an or
    typeText = typeText.replace(/,([^,]*)$/, ' or$1');

    return [
        `Logos must be uploaded as ${typeText} files`
    ];
});
</script>

<template>
    <StfSubHeading>Upload logo</StfSubHeading>
    <StfFileInput
        :max-size-m-b="country.imageOptions.maxSize"
        :allowed-types="country.imageOptions.fileType"
        :loading="loading"
        :error="error"
        :preview="trademarkImageUrl"
        @fileSelected="uploadImage"
        @file-removed="removeImage"
        class="my-2"
    ></StfFileInput>
    <StfBulletPoint :items="helperText"></StfBulletPoint>
</template>

<style scoped>

</style>
